var render = function render(_c,_vm){return _c('tbody',[_c('tr',[_c('td',[_c('ui-link',{staticClass:"tx-table-cell-icon tx-table-cell-icon--compact",attrs:{"to":{
                name: 'tx',
                params: { hash: _vm.props.hash },
            }}},[_c('icon-chain')],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(_vm.props.seqno)}}),_vm._v(" "),_c('td',[_c('ui-address',{attrs:{"address":_vm.props.account}})],1),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.props.lt)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.props.hash)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }